import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { MyCheckbox, TextInput } from "../Shared/Forms";
import CoreDomains from "../ISW-Core/Domains";

import { Spinner } from "../Shared";

import { institutionActions } from "./actions/institutions.actions";
import { routeConstants } from "../../_constants";

export class InstitutionForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getInstitution();
  }

  componentWillUnmount() {
    this.props.resetInstitution();
  }

  getInstitution = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getInstitution(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.institutionForm.reset();
      if (this.coreDomains) {
        this.coreDomains.domainCode.changeValue(null);
      }
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  createRequest = data => {
    let request = { ...data };

    if (request.institution) {
      request = {
        code: request.institution.code,
        description: request.institution.name,
        ...request
      };
      delete request.institution;
    }

    return request;
  };

  handleSubmit = data => {
    let requestBody = this.createRequest(data);
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      requestBody = {
        id: match.params.id,
        ...requestBody
      };
    }
    this.props.addInstitution(requestBody);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const institution =
      viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.INSTITUTIONS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Institution
                <small>
                  {institution && hasParams ? `: ${institution.code}` : null}
                </small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="institutionForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                {hasParams ? (
                  <div>
                    <TextInput
                      name="code"
                      value={institution && hasParams ? institution.code : null}
                      required
                      disabled={submitting || hasParams}
                      title="Institution code"
                    />

                    <TextInput
                      name="description"
                      value={institution && hasParams ? institution.description : null}
                      required
                      disabled={submitting}
                      title="Institution description"
                    />
                  </div>
                ) : (
                  <CoreDomains
                    value={institution && hasParams ? institution.code : ""}
                    disabled={submitting || hasParams}
                    name="institution"
                    innerRef={c => {
                      this.coreDomains = c;
                    }}
                  />
                )}
                <MyCheckbox
                  name="enabled"
                  title="Enable institution"
                  validating={submitting}
                  value={institution && hasParams ? institution.enabled : false}
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    submitting,
    submitted,
    request,
    response,
    error
  } = state.addInstitution;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewInstitution;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addInstitution: bindActionCreators(
      institutionActions.addInstitution,
      dispatch
    ),
    resetInstitution: bindActionCreators(
      institutionActions.resetInstitution,
      dispatch
    ),
    getInstitution: bindActionCreators(
      institutionActions.getInstitution,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InstitutionForm);
